import { Component, OnInit, AfterViewInit, Input, ViewChild, ViewChildren, ChangeDetectorRef, QueryList } from '@angular/core';
import { BENEFITS_TYPES, PlanDetailsRenderableCategory } from '../types/plan-details.types';
import { MatAccordion, MatExpansionPanel } from '@angular/material/expansion';
import { BenefitCategoryComponent } from './benefit-category/benefit-category.component';

@Component({
    selector: 'app-benefit-grid',
    templateUrl: './benefit-grid.component.html',
    styleUrls: ['./benefit-grid.component.scss'],
    standalone: false
})
export class BenefitGridComponent implements OnInit, AfterViewInit {
  multi = false;
  currentBenefitCategory?: BenefitCategoryComponent; 
  

  @Input() plans: PlanDetailsRenderableCategory[];
  @Input() market: string;
  @Input() isFirstRow: boolean; 
  

  @ViewChild(MatAccordion) accordion: MatAccordion;
  @ViewChildren(BenefitCategoryComponent) panels: QueryList<BenefitCategoryComponent>;

  constructor(private changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnInit() {
    
    /**
     * Filter out the iconography in the benefit grids until such a time that it is removed from
     * the benefits information in the service response.
     *
     * Iconography is only, now, used in the headers of the plan details and compare plans views
     */

    this.plans
      = this.plans.filter(benefitCategories => {
        return benefitCategories.categoryName.replace(/ /g, '_').toUpperCase() !== BENEFITS_TYPES.ICONOGRAPHY;
      });
  }

  ngAfterViewInit(): void {
    window.addEventListener('beforeprint', () => {
      this.beforePrint() 
    });
    window.addEventListener('afterprint', () => {
      this.afterPrint() 
    });
  }


  beforePrint(): void {
    this.panels.forEach((panel) => {
      if(panel.panel.expanded === true) {
        this.currentBenefitCategory = panel; 
      }
    })
    this.multi = true;
    this.changeDetectorRef.detectChanges();
    this.accordion.openAll();
    this.changeDetectorRef.detectChanges();
  }

  afterPrint(): void{
    this.accordion.closeAll();
    this.multi = false; 
    this.changeDetectorRef.detectChanges(); 
    this.currentBenefitCategory.togglePanel();
    this.changeDetectorRef.detectChanges(); 
  }


}
